import { memo } from 'react';
import Slider from '@dtvgo/slider';
import { ProgressBarClassNames } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function ProgressFill(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx(Slider.Fill, {
    className: ProgressBarClassNames.element('progress-fill', className)
  });
}
var ProgressFill$1 = /*#__PURE__*/memo(ProgressFill);

export { ProgressFill$1 as default };
//# sourceMappingURL=ProgressFill.js.map
